import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { connect } from 'dva';
import { getQueryString} from '@/utils/index';
import styles from './index.less';
import api from '@/common/api';
const nodata = require('./imgs/nodata@2x.png');
const networkerror3 = require('./imgs/networkerror3@3x.png');
const CheckLoading = (props) => {
  const type = getQueryString('type');
  return (
    <div className={styles.errorPage}>
      <div className={styles.netWorkerror}>
        <img src={networkerror3} />
        {type === 'nocard' ? '请勿非法访问!' : '您的福利卡未激活'}
      </div>
    </div>
  );
};
export default CheckLoading;
